var $ = require('jquery'),
	$anchors = $('a[href*="#"]'),
	$menuCheck = $('#main-navigation'),
  $inputMoreMobile = $('.nav__show-more-mobile');

$( document ).ready(function() {
  $($anchors)
    .not('[href="#"]')
    .not('[href="#0"]')
    .click(function(event) {
      if (
        location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
        && 
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
        $menuCheck.prop( "checked", false );
        if (target.length) {
          event.preventDefault();
          $('html, body').animate({
            scrollTop: target.offset().top
          }, 500, function() {
            var $target = $(target);
            $target.focus();
            if($inputMoreMobile) {
              $inputMoreMobile.prop('checked', false);
            }
            if ($target.is(":focus")) { 
              return false;
            } else {
              $target.attr('tabindex','-1');
              $target.focus();
            };
          });
        }
      }
    });
});